import { ROUTE_PATH } from 'lib/paths'
import { useIsSelfUser } from '../../lib/useIsSelfUser'
import { endpoints } from 'store/api/yay/user'
import { unWei } from 'lib/helpers'

import { useEMPLDetails } from 'features/Bag/useBagDetails'
import ImageLoader from 'components/ImageLoader'
import UserMenu from '../UserMenu'
import Button from 'components/Button'

const UserWallpaper = ({ userId }: { userId: number }) => {
  const isSelfUser = useIsSelfUser(userId)

  const userRes = endpoints?.getUser?.useQueryState?.({
    userId: userId?.toString?.(),
  })

  const emplDetailsRes = useEMPLDetails()

  return (
    <div className="User__wallpaper__wrapper">
      <ImageLoader
        className="User__wallpaper"
        url={userRes?.data?.cover_image}
        placeholderImage="/images/transparent-bg.png"
        alt={`${userRes?.data?.nickname}のカバー写真`}
        enableRetry
      />

      <div className="User__floating-menu">
        {isSelfUser && (
          <Button
            icon="empl"
            buttonStyle="bordered-gray-without-bg-dark-text"
            className="User__floating-menu__empl"
            to={ROUTE_PATH.EMPL_DETAILS}
          >
            {unWei(
              Number(emplDetailsRes?.data?.empl?.total ?? 0)
            ).toLocaleString()}
          </Button>
        )}
        {!isSelfUser && <UserMenu hideArrow icon="3dots-v" />}
      </div>
    </div>
  )
}

export default UserWallpaper
